import { Close } from "@mui/icons-material";
import { Grid, SxProps, Theme } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

import RecuroLogo from "../../assets/recuro-logo-horizontal-full.svg";
import { Button } from "../Button/Button";

export interface HeaderProps {
  sx?: SxProps<Theme>;
  isCloseVisible?: boolean;
  onClose?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  isCloseVisible,
  sx = {},
  onClose = null,
}) => {
  const { formatMessage } = useIntl();

  const close = isCloseVisible && (
    <Button
      type="text"
      onClick={() => onClose && onClose()}
      aria-label={formatMessage({ id: "header.close.ariaLabel" })}
    >
      <Close aria-hidden="true" />
    </Button>
  );

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={sx}
      component="header"
    >
      <Grid
        item
        xs={6}
      >
        <img
          src={RecuroLogo}
          alt={formatMessage({ id: "header.logo.alt" })}
          style={{
            width: "171px",
            height: "41px",
            objectFit: "contain",
          }}
        />
      </Grid>
      <Grid
        item
        xs={2}
        sm={1}
      >
        {close}
      </Grid>
    </Grid>
  );
};
